module.exports = __webpack_public_path__ + "static/img/cashback.136c4ee4.jpg";